import EventHubMixin from '@/mixins/EventHub.js'
import TimeMixin from '@/mixins/Time.js'
import SizesMixin from '@/mixins/Sizes.js'
import MouseMixin from '@/mixins/Mouse.js'

export default
{
    name: 'app-interaction-simulation',

    mixins:
    [
        TimeMixin,
        EventHubMixin,
        SizesMixin,
        MouseMixin
    ],

    props:
    {
        content: { type: Object, default: () => {} }
    },

    data()
    {
        return {
            height: 600,
            isOver: false
        }
    },

    created()
    {
        this.height = window.innerHeight
    },

    mounted()
    {
        this.buttons = {}
        this.buttons.$items = [...this.$el.querySelectorAll('.js-button')]

        const buttonsMapping = {
            zPos: 'up',
            zNeg: 'down',
            xPos: 'left',
            xNeg: 'right',
            yPos: 'shift',
            yNeg: 'space'
        }

        for(const $item of this.buttons.$items)
        {
            const buttonName = $item.dataset.buttonName
            $item.addEventListener('click', (_event) =>
            {
                _event.preventDefault()
            })

            $item.addEventListener('mousedown', (_event) =>
            {
                _event.preventDefault()

                this.$eventHub.$emit('experience.simulation.uiButtonDown', buttonName)

                const mouseupCallback = () =>
                {
                    _event.preventDefault()

                    this.$eventHub.$emit('experience.simulation.uiButtonUp', buttonName)
                    document.removeEventListener('mouseup', mouseupCallback)
                }

                document.addEventListener('mouseup', mouseupCallback)
            })

            $item.addEventListener('contextmenu', (_event) =>
            {
                _event.preventDefault()
            })

            $item.addEventListener('touchstart', (_event) =>
            {
                _event.preventDefault()
                if(_event.stopPropagation)
                {
                    _event.stopPropagation()
                }
                _event.cancelBubble = true
                _event.returnValue = false

                this.$eventHub.$emit('experience.simulation.uiButtonDown', buttonName)

                const touchendCallback = (_event) =>
                {
                    _event.preventDefault()

                    this.$eventHub.$emit('experience.simulation.uiButtonUp', buttonName)
                    document.removeEventListener('touchend', touchendCallback)
                }

                document.addEventListener('touchend', touchendCallback)
            })
        }

        this.$eventHub.$on('experience.simulation.buttonDown', (_directionName) =>
        {
            const buttonName = buttonsMapping[_directionName]
            const $button = this.buttons.$items.find(($button) =>
            {
                return $button.dataset.buttonName === buttonName
            })

            if($button)
            {
                $button.classList.add('is-active')
            }
        })

        this.$eventHub.$on('experience.simulation.buttonUp', (_directionName) =>
        {
            const buttonName = buttonsMapping[_directionName]
            const $button = this.buttons.$items.find(($button) =>
            {
                return $button.dataset.buttonName === buttonName
            })

            if($button)
            {
                $button.classList.remove('is-active')
            }
        })

        let alertTimeout = null

        this.$eventHub.$on('experience.simulation.choked', () =>
        {
            this.$refs.instructions.classList.add('is-alert')

            if(alertTimeout)
            {
                window.clearTimeout(alertTimeout)
            }

            alertTimeout = window.setTimeout(() =>
            {
                this.$refs.instructions.classList.remove('is-alert')
                alertTimeout = null
            }, 500)
        })

        this.$eventHub.$on('experience.simulation.won', () =>
        {
            this.$eventHub.$emit('sound.play', 'valid')
            this.isOver = true
        })
    },

    destroyed()
    {
        this.$eventHub.$off('experience.simulation.buttonDown')
        this.$eventHub.$off('experience.simulation.buttonUp')
        this.$eventHub.$off('experience.simulation.choked')
        this.$eventHub.$off('experience.simulation.won')
    },

    methods:
    {
        onResize()
        {
            this.height = window.innerHeight
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-interaction-simulation/script.js